import { createElement, lazy } from 'react';
import type { RouteObject } from 'react-router';

import { GuardedView, ProtectedRoute } from '@/features/auth/components/ProtectedRoute';

const ProductObservationsPage = lazy(() =>
  import('./pages/ProductObservationsPage').then((module) => ({
    default: module.ProductObservationsPage,
  })),
);

const WarehouseProductObservationsPage = lazy(() =>
  import('./pages/WarehouseProductObservationsPage').then((module) => ({
    default: module.WarehouseProductObservationsPage,
  })),
);

const ProductObservationDetailPage = lazy(() =>
  import('./pages/ProductObservationDetailPage').then((module) => ({
    default: module.ProductObservationDetailPage,
  })),
);

/**
 * Gating:
 * - the index is the creation screen: requires `add_productobservation`;
 * - the bandeja and the detail are the shared views: reachable with either the
 *   own-site permission or the whole-history one.
 */
export const productObservationsRoutes: RouteObject[] = [
  {
    path: 'productos-observados',
    element: createElement(ProtectedRoute),
    children: [
      {
        index: true,
        element: createElement(GuardedView, {
          view: 'productObservations',
          children: createElement(ProductObservationsPage),
        }),
      },
      {
        path: 'almacen',
        element: createElement(GuardedView, {
          view: 'warehouseProductObservations',
          children: createElement(WarehouseProductObservationsPage),
        }),
      },
      {
        path: ':id',
        element: createElement(GuardedView, {
          view: 'productObservationDetail',
          children: createElement(ProductObservationDetailPage),
        }),
      },
    ],
  },
];
